import {
  CLEAR_BOARD_IMPORT_EXPORT_STATE,
  GET_BOARD_IMPORT_EXPORT_PROFILES,
  SET_BOARD_IMPORT_EXPORT_LOADING,
  SET_BOARD_IMPORT_EXPORT_PREVIEW,
  SET_BOARD_IMPORT_EXPORT_RESULT,
} from "./boardImportExportTypes";

const initialState = {
  loading: false,
  profiles: null,
  preview: null,
  result: null,
};

export const boardImportExportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_BOARD_IMPORT_EXPORT_LOADING:
      return {
        ...state,
        loading: action.Payload,
      };
    case GET_BOARD_IMPORT_EXPORT_PROFILES:
      return {
        ...state,
        profiles: action.Payload,
      };
    case SET_BOARD_IMPORT_EXPORT_PREVIEW:
      return {
        ...state,
        preview: action.Payload,
      };
    case SET_BOARD_IMPORT_EXPORT_RESULT:
      return {
        ...state,
        result: action.Payload,
      };
    case CLEAR_BOARD_IMPORT_EXPORT_STATE:
      return initialState;
    default:
      return state;
  }
};
